(function () {
  'use strict';

  /**
   * @ngdoc object
   *
   * @description
   *
   */
  angular
    .module('salesTarget')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})

    .controller('salesTargetCtrl', salesTarget);


  function salesTarget(PopupManager,CommonMasterData,salesTargetService,MessageService,  $http) {
    var vm = this;
    vm.ctrlName = 'salesTarget';

    vm.model = {
            masterList: {
            	roleNameList:[],
            },
            initialSearchDone:false,
            annualLeaveBidding:{
              remarks : '',
              file : [],
            },
            filename:'',
            currentTime:'',
            uploadUrl:'',
            formData:null,
            bulkResponseList:[],
            resultList:[],
            loading:false,
            bulkUpdateFileNameForReference:'',
        };

    getResponseData();

    vm.uploadFile = function () {
      // vm.model.loading = true;
      vm.model.bulkResponseList = [];
      vm.model.filename = event.target.files[0];
      var currentTime = new Date();
      vm.model.currentTime = currentTime;
      vm.model.uploadUrl = "/admin/aeroLineCrewAdmin/crewingService/save/salesTarget";
      vm.model.formdata = new FormData();
      vm.model.formdata.append('fileMeta', vm.model.filename);

      $http.post(vm.model.uploadUrl, vm.model.formdata, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function (response) {
          if(response.validationMessage != null) {
            vm.model.filename = '';
            var message = response.validationMessage;
            var details = {
              title: 'Upload Result',
              messages: [message]

            };
            PopupManager.openModal('INFO_DIALOG', details, locationreload);

            // locationreload();

          }else {
            MessageService.success(MessageService.MESSAGES.SALES_TARGET.UPLOAD_SUCCESS);
            vm.model.bulkUpdateFileNameForReference = response.bulkUpdateFileNameForReference;
          }
        })

        .error(function (response) {
          MessageService.error(response.error);
        });

    };


    // $interval.cancel(angularInterval);

    vm.printInterval = function () {
      console.log("event run");
    }

    vm.saveCsvFile = function () {
      if(!angular.equals(vm.model.filename,'')) {
        $http.post(vm.model.uploadUrl, vm.model.formdata, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        })
          .success(function (response) {
            if(response.validationMessage!=null){
              vm.model.formdata = null;
              MessageService.error(response.validationMessage);
            }else{
              MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
              vm.model.bulkResponseList = response.assignDutyResponse;
            }

          })

          .error(function (response) {
            MessageService.error(response.error);
          });
      }else{
        MessageService.error(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
      }
    }

    function getResponseData() {
          var param = {};
          param.bulkUpdateFileNameForReference = vm.model.bulkUpdateFileNameForReference;
          salesTargetService.getSalesTargetResponse(
            function (response) {
              if (response.success) {
                if (response.salesTarget != null) {
                  vm.model.bulkResponseList = response.salesTarget;
                }
              } else {
                MessageService.error(response.errors[0]);
              }
            },
            function (error) {
              MessageService.error(error);
            }
          );

    }

    function locationreload(pass) {
      if(pass==='YES') {
        location.reload();
      }

    }

  }
}());
